import { ImportInternationalCustomsCsvResult } from "@redotech/redo-inventory-common/international-customs-upload";
import * as z from "zod";

export const ImportInternationalCustomsCsvStatus = z.enum([
  "running",
  "completed",
  "failed",
  "not_found",
]);
export type ImportInternationalCustomsCsvStatus = z.infer<
  typeof ImportInternationalCustomsCsvStatus
>;

export const getImportInternationalCustomsCsvStatus = {
  name: "getImportInternationalCustomsCsvStatus" as const,
  input: z.object({ workflowId: z.string() }),
  output: z.object({
    status: ImportInternationalCustomsCsvStatus,
    failureMessage: z.string().optional(),
    result: ImportInternationalCustomsCsvResult.optional(),
  }),
};
